import React, { useState } from "react";

const PaginationButtons = ({
  page,
  total,
  prevPage,
  nextPage,
  pageSelected,
}) => {
  const [limit, setLimit] = useState(process.env.REACT_APP_PAGINATION_LIMIT);
  return (
    <>
      <div
        className="dataTables_info"
        id="dtscase_info"
        role="status"
        aria-live="polite"
      >
        Showing {Math.min((page - 1) * limit + 1, total)} to{" "}
        {Math.min(page * limit, total)} of {total} entries
      </div>
      <div
        className="dataTables_paginate paging_simple_numbers"
        id="dtscase_paginate"
      >
        <button
          className={`paginate_button previous ${page <= 1 ? "disabled" : ""}`}
          aria-controls="dtscase"
          data-dt-idx="0"
          id="dtscase_previous"
          onClick={(e) => prevPage(e)}
          disabled={page <= 1 || total === 0}
        >
          Previous
        </button>
        {total > 0 && (
          <span>
            <span>
              <a
                href="/#"
                className={`paginate_button ${page === 1 ? "current" : ""}`}
                onClick={(e) => pageSelected(e, 1)}
              >
                1
              </a>
              {(() => {
                const pages = Math.ceil(total / limit);
                const ellipsis = (key) => {
                  return (
                    <span key={key} className="ellipsis">
                      …
                    </span>
                  );
                };

                const items = [];
                if (page <= 4) {
                  for (let i = 2; i <= Math.min(pages, 5); i++) {
                    items.push(
                      <a
                        href="/#"
                        key={i}
                        className={`paginate_button ${
                          page === i ? "current" : ""
                        }`}
                        onClick={(e) => pageSelected(e, i)}
                      >
                        {i}
                      </a>
                    );
                  }
                  if (pages > 5) items.push(ellipsis("ellipsis1"));
                } else if (page > 4 && page < pages - 3) {
                  items.push(ellipsis("ellipsis2"));
                  for (let i = page - 1; i <= page + 1; i++) {
                    items.push(
                      <a
                        href="/#"
                        key={i}
                        className={`paginate_button ${
                          page === i ? "current" : ""
                        }`}
                        onClick={(e) => pageSelected(e, i)}
                      >
                        {i}
                      </a>
                    );
                  }
                  items.push(ellipsis("ellipsis3"));
                } else {
                  if (pages !== 5) items.push(ellipsis("ellipsis4"));
                  for (
                    let i = Math.max(2, pages - 4);
                    i < Math.max(6, pages);
                    i++
                  ) {
                    items.push(
                      <a
                        href="/#"
                        key={i}
                        className={`paginate_button ${
                          page === i ? "current" : ""
                        }`}
                        onClick={(e) => pageSelected(e, i)}
                      >
                        {i}
                      </a>
                    );
                  }
                }

                return items;
              })()}
              {Math.ceil(total / limit) > 5 && (
                <a
                  href="/#"
                  className={`paginate_button ${
                    page === Math.ceil(total / limit) ? "current" : ""
                  }`}
                  onClick={(e) => pageSelected(e, Math.ceil(total / limit))}
                >
                  {Math.ceil(total / limit)}
                </a>
              )}
            </span>
          </span>
        )}
        <button
          className={`paginate_button next ${
            page === Math.ceil(total / limit) || total === 0 ? "disabled" : ""
          }`}
          aria-controls="dtscase"
          data-dt-idx="7"
          id="dtscase_next"
          onClick={(e) => nextPage(e)}
          disabled={page === Math.ceil(total / limit) || total === 0}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default PaginationButtons;
